import React from "react";
import { Container } from "./styles";
import TitleSection from "../../TitleSection";
import partnersBg from "../../../assets/images/PartnersBg.png";
import imgCoinGecko from "../../../assets/images/Coingecko.png";
import imgCoinMarketCap from "../../../assets/images/CoinMarketCap.png";
import imgDextTools from "../../../assets/images/DextTools.png";
import imgDexView from "../../../assets/images/DexView.png";
import imgEthScan from "../../../assets/images/EthScan.png";
import imgPinkSale from "../../../assets/images/Pinksale.png";
import Slider from "react-slick";

const Partners = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 350,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };
  const allPartenrs = [
    {
      name: "CoinGecko",
      image: imgCoinGecko,
      href: "",
    },
    {
      name: "CoinMarketCap",
      image: imgCoinMarketCap,
      href: "",
    },
    {
      name: "DextTools",
      image: imgDextTools,
      href: "",
    },
    {
      name: "DexView",
      image: imgDexView,
      href: "",
    },
    {
      name: "ETHScan",
      image: imgEthScan,
      href: "",
    },
    {
      name: "PinkSale",
      image: imgPinkSale,
      href: "",
    },
  ];
  return (
    <Container>
      <h2 className="dc-title">Our Partners</h2>

      {/* <p className="partners-subtitle">
        Partnership Youtubers, and AMA Channels
      </p> */}
      <Slider className="partners-content" {...settings}>
        {allPartenrs.map((partners, index) => (
          <div className="partners-card" key={`partners__${index}`}>
            <img src={partnersBg} alt="" className="dc-background-img" />
            <a href={partners.href}>
              <img src={partners.image} alt=""  loading="lazy"/>
              {/* <div className="partners-card__img">
                <img src={partners.image} alt="" />
              </div>
              <p>{partners.name}</p> */}
            </a>
          </div>
        ))}
      </Slider>
      <br />
    </Container>
  );
};

export default Partners;
